import React from "react";
import "./SkeletonStyle/SkeletonStyle.css";

export const SidebarProfileSkeleton = ({ theme }) => {
  const skeletonColor = theme === "dark" ? "#2f2f2f" : "#e0e0e0";

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "2rem",
      }}
    >
      <div
        className="skeleton"
        style={{
          width: "128px",
          height: "128px",
          borderRadius: "50%",
          marginBottom: "0",
          backgroundColor: skeletonColor,
        }}
      ></div>
      <div
        className="skeleton"
        style={{
          width: "120px",
          height: "20px",
          marginTop: "2rem",
          marginBottom: "0",
          backgroundColor: skeletonColor,
        }}
      ></div>
    </div>
  );
};
